import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
export const CalendarDate = ({ day, month }) => (_jsxs(CalendarDateWrapper, { dataTestId: "calendar-date", children: [_jsx(Box, { color: "black", font: "h4-semibold", children: day }), _jsx(Box, { color: "black", font: "metadata-regular-asphalt", children: month.slice(0, 3) })] }));
const CalendarDateWrapper = styled(Box).attrs({
    p: 1,
}) `
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  min-width: 40px;
`;
//# sourceMappingURL=CalendarDate.js.map